import React from "react";
import "../style/Home.css";
import "../style/Common.css";
import { useMediaQuery } from "react-responsive";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faAngleRight } from "@fortawesome/free-solid-svg-icons";

const Home = () => {
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

  return (
    <div className="home" id="home">
      <Carousel
        className="home-carousel"
        showThumbs={false}
        autoPlay
        infiniteLoop
        showStatus={false}
        showIndicators={false}
        swipeable={false}
        transitionTime={600}
        interval={5000}
        showArrows={isMobile ? false : true}
        renderArrowPrev={(onClickHandler, hasPrev, label) =>
          hasPrev && (
            <button
              type="button"
              onClick={onClickHandler}
              title={label}
              className="control-arrow control-prev"
            >
              <FontAwesomeIcon icon={faAngleLeft} />
            </button>
          )
        }
        renderArrowNext={(onClickHandler, hasNext, label) =>
          hasNext && (
            <button
              type="button"
              onClick={onClickHandler}
              title={label}
              className="control-arrow control-next"
            >
              <FontAwesomeIcon icon={faAngleRight} />
            </button>
          )
        }
      >
        <div>
          <img
            src={
              isMobile
                ? require("../images/home_2_mobile.jpeg")
                : require("../images/home_1.jpeg")
            }
            alt="dentist"
          />
          <div
            className="content"
            style={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div
              style={{
                width: isMobile ? "90%" : "55rem",
                paddingBottom: isMobile ? "2rem" : "0",
              }}
            >
              <h2>Discover the Smile You’ve Always Wanted!</h2>
            </div>
            <h3>
              Book a Free Expert Consultation
              {isMobile ? "" : " Now"}
            </h3>
            <br />
            <br />
            <a
              href="#contact"
              className="link-btn"
              style={{
                marginTop: isMobile ? "15%" : "",
              }}
            >
              Book Now
            </a>
          </div>
        </div>
        <div>
          <img
            src={
              isMobile
                ? require("../images/home_1_mobile.jpeg")
                : require("../images/home_2.jpeg")
            }
            alt="female dentist"
          />
          <div
            className="content"
            style={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div
              style={{
                width: isMobile ? "90%" : "55rem",
                paddingBottom: isMobile ? "2rem" : "0",
              }}
            >
              <h2>Start Your Journey to a Perfect Smile Today!</h2>
            </div>
            <h3>Get a Free Consultation with Our Experts</h3>
            <br />
            <br />
            <a
              href="#contact"
              className="link-btn"
              style={{
                marginTop: isMobile ? "15%" : "3rem !important",
              }}
            >
              Get Started
            </a>
          </div>
        </div>
      </Carousel>
    </div>
  );
};

export default Home;
